import Dexie, { Table } from 'dexie';

interface StoredFile {
  offline_ref: true;
  photo_ref: { type: 'base64' | 'path'; value: string; filename: string; mimeType?: string };
  name: string;
  type: string;
  note: string;
  timing?: string | null;
}

interface SubmissionDraft {
  task_id: number;
  user_id: string;
  attachments: Record<string, StoredFile[]>; // key = settingId as string
  additional_files: StoredFile[];
  saved_at: string;
}

class SubmissionDraftDB extends Dexie {
  drafts!: Table<SubmissionDraft, number>;
  constructor() {
    super('teratask_submission_draft');
    this.version(1).stores({ drafts: 'task_id, user_id' });
  }
}

const db = new SubmissionDraftDB();

export const submissionDraft = {
  async save(draft: SubmissionDraft): Promise<void> {
    await db.drafts.put(draft);
  },
  async get(taskId: number, userId: string): Promise<SubmissionDraft | null> {
    const draft = await db.drafts.get(taskId);
    if (!draft || draft.user_id !== userId) return null;
    return draft;
  },
  async clear(taskId: number): Promise<void> {
    await db.drafts.delete(taskId);
  },
};
